var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftSolid = function SvgGiftSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7.25h-.761a3.25 3.25 0 0 0-2.732-5c-1.231-.019-2.37.583-3.277 1.592A7.793 7.793 0 0 0 12 5.732a7.793 7.793 0 0 0-1.23-1.89c-.908-1.01-2.046-1.61-3.277-1.592a3.25 3.25 0 0 0-2.732 5H4A1.75 1.75 0 0 0 2.25 9v2c0 .967.784 1.75 1.75 1.75h.25V19A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19v-6.25H20A1.75 1.75 0 0 0 21.75 11V9A1.75 1.75 0 0 0 20 7.25ZM7.513 3.75c.696-.012 1.447.322 2.142 1.095.539.599 1.004 1.42 1.345 2.405H7.5a1.75 1.75 0 1 1 0-3.5h.013Zm8.978 3.5H13c.34-.986.806-1.806 1.345-2.405.695-.773 1.446-1.107 2.142-1.095h.013a1.75 1.75 0 0 1 0 3.5h-.009Zm-5.241 5.5v7.5h1.5v-7.5h-1.5Zm1.5-4v2.5h-1.5v-2.5h1.5Z",
    fill: "currentColor"
  })));
};
export default SvgGiftSolid;